export default "__VITE_ASSET__a1fbffc0__"